import { BaseModel } from "@blue-chip/core";
import User from "./User";

export default class Rfq extends BaseModel {
  static get belongsTo() {
    return [User];
  }
}
